import React from 'react';
import {
  LinearProgress,
  makeStyles,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  progress: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    height: '100px',
    padding: '100px'
  },
}));

const ProgressBar = () => {
  const classes = useStyles();

  return (
    <div className={classes.progress}>
      <Typography variant="span">
        Yükleniyor..
      </Typography>
      <LinearProgress title="Yükleniyor.." />
    </div>
  );
};

export default ProgressBar;
